import React from 'react'
import classNames from 'classnames'

export const Chip = ({ text, children, className, as, ...props }) => {
  const El = as || 'span'
  return (
    <El {...props} className={classNames('search-mxd-chip', className)}>
      {text ?? children}
    </El>
  )
}
